/* Fürbitten-Generator (Christian am 09.10.2026). Ruft das ERP auf
   (erp.kerzenonkel.de/shop-fuerbitten), das Claude formulieren lässt.
   Der Name des Kindes wird NICHT gesendet: Die Antwort enthält {NAME},
   eingesetzt wird erst hier im Browser. Ausgabe nur über textContent. */
(function () {
  var ENDPUNKT = 'https://erp.kerzenonkel.de/shop-fuerbitten';
  // Bot-Schutz (Christian 09.10.2026): signierte Rechenaufgabe vom ERP, hier gelöst
  // (SHA-256 mit führenden Null-Bits). Wird schon beim Aufklappen geholt und im
  // Hintergrund gelöst, damit der Klick auf „erstellen“ nicht warten muss.
  var vorrat = null;
  function nullBits(h) {
    var n = 0;
    for (var i = 0; i < h.length; i++) {
      if (h[i] === 0) { n += 8; continue; }
      for (var b = 7; b >= 0; b--) { if (h[i] & (1 << b)) return n; n++; }
    }
    return n;
  }
  function loesen(a) {
    var enc = new TextEncoder();
    var n = 0;
    function schritt() {
      var stapel = [];
      for (var k = 0; k < 256; k++) stapel.push(crypto.subtle.digest('SHA-256', enc.encode(a.aufgabe + (n + k))));
      return Promise.all(stapel).then(function (hs) {
        for (var k = 0; k < hs.length; k++) {
          if (nullBits(new Uint8Array(hs[k])) >= a.bits) { a.loesung = String(n + k); return a; }
        }
        n += 256; return schritt();
      });
    }
    return schritt();
  }
  function aufgabeHolen() {
    vorrat = fetch(ENDPUNKT + '/aufgabe', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (a) { a.geholt = Date.now(); return loesen(a); });
    vorrat.catch(function () { vorrat = null; });
    return vorrat;
  }
  function aufgabeNehmen() {
    var p = vorrat || aufgabeHolen();
    vorrat = null;
    return p.then(function (a) {
      var warten = 2200 - (Date.now() - a.geholt);   // Server verlangt >= 2 Sek. Alter
      return new Promise(function (ok) { setTimeout(function () { ok(a); }, Math.max(0, warten)); });
    });
  }
  var box = document.getElementById('fzt-gen');
  if (!box) return;
  var form = box.querySelector('form');
  var status = box.querySelector('.fzt-gen__status');
  var ausgabe = box.querySelector('.fzt-gen__ergebnis');
  var liste = ausgabe.querySelector('ol');
  var knopf = form.querySelector('button[type="submit"]');
  var kopieren = box.querySelector('[data-fzt-kopieren]');
  var nochmal = box.querySelector('[data-fzt-nochmal]');
  var letzte = null;

  // Aufklappbar (Christian 09.10.2026): Links auf #fzt-gen (Inhaltsverzeichnis,
  // Abschnitt „Selbst schreiben“) öffnen den Generator.
  function oeffnen() { if (box.tagName === 'DETAILS') box.open = true; }
  // Aufgabe holen, sobald jemand den Generator öffnet (nicht schon beim Seitenaufruf —
  // wer ihn nie öffnet, verursacht keinen Abruf).
  box.addEventListener('toggle', function () { if (box.open && !vorrat) aufgabeHolen(); });
  if (box.open && !vorrat) aufgabeHolen();
  if (location.hash === '#fzt-gen') oeffnen();
  window.addEventListener('hashchange', function () { if (location.hash === '#fzt-gen') oeffnen(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#fzt-gen"]');
    if (a) oeffnen();
  });

  function werte(name) {
    return Array.prototype.map.call(form.querySelectorAll('input[name="' + name + '"]:checked'), function (e) { return e.value; });
  }
  function meldung(text, fehler) {
    status.textContent = text || '';
    status.className = 'fzt-gen__status' + (fehler ? ' fzt-gen__status--fehler' : '');
  }
  function name() {
    var n = (form.elements.kindname.value || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    return n || '[Name]';
  }
  function zeigen() {
    if (!letzte) return;
    var n = name();
    liste.innerHTML = '';
    letzte.fuerbitten.forEach(function (t) {
      var li = document.createElement('li');
      li.appendChild(document.createTextNode(t.split('{NAME}').join(n)));
      var ruf = document.createElement('span');
      ruf.className = 'fzt-gen__ruf';
      ruf.textContent = letzte.antwortruf;
      li.appendChild(ruf);
      liste.appendChild(li);
    });
    ausgabe.hidden = false;
  }
  function alsText() {
    var n = name();
    return letzte.fuerbitten.map(function (t, i) {
      return (i + 1) + '. ' + t.split('{NAME}').join(n) + '\n   ' + letzte.antwortruf;
    }).join('\n\n');
  }

  // Mehrere Taufkinder (Christian 09.10.2026, Zwillinge): nur die ANZAHL geht ans ERP,
  // die Namen bleiben im Browser. „Raja und Zoe“, „Anna & Ben“, „Lea, Tom, Max“.
  function kinderZahl() {
    var n = (form.elements.kindname.value || '').split(/\s*(?:,|&|\+|\/|\bund\b)\s*/i)
      .filter(function (t) { return t.trim().length > 0; }).length || 1;
    var sw = form.elements.stichwort.value || '';
    if (/zwilling/i.test(sw)) n = Math.max(n, 2);
    if (/drilling/i.test(sw)) n = Math.max(n, 3);
    return Math.min(n, 4);
  }

  function anfragen() {
    var themen = werte('thema');
    if (!themen.length) { meldung('Bitte wähle mindestens ein Thema.', true); return; }
    if (themen.length > 4) { meldung('Bitte wähle höchstens vier Themen.', true); return; }
    var daten = {
      konfession: (form.querySelector('input[name="konfession"]:checked') || {}).value || 'frei',
      ton: (form.querySelector('input[name="ton"]:checked') || {}).value || 'modern',
      sprecher: werte('sprecher'),
      themen: themen,
      anzahl: parseInt(form.elements.anzahl.value, 10) || 4,
      stichwort: (form.elements.stichwort.value || '').slice(0, 80),
      kinder: kinderZahl(),
      // Christian 12.10.2026: männlich/weiblich/divers – ohne Auswahl neutral formuliert
      geschlecht: (form.querySelector('input[name="geschlecht"]:checked') || {}).value || 'divers'
    };
    daten.website = form.elements.website ? form.elements.website.value : '';
    knopf.disabled = true; if (nochmal) nochmal.disabled = true;
    meldung(''); var schreiben = box.querySelector('.fzt-gen__schreiben'); if (schreiben) schreiben.hidden = false;
    aufgabeNehmen()
      .then(function (a) {
        daten.aufgabe = a.aufgabe; daten.signatur = a.signatur; daten.loesung = a.loesung;
        return fetch(ENDPUNKT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(daten) });
      })
      .then(function (r) { aufgabeHolen(); return r.json().catch(function () { return { ok: false }; }); })
      .then(function (d) {
        if (d && d.ok && d.fuerbitten) {
          letzte = d; zeigen(); meldung('');
          ausgabe.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          meldung((d && d.fehler) || 'Das hat gerade nicht geklappt. Bitte versuch es noch einmal.', true);
        }
      })
      .catch(function () { meldung('Der Generator ist gerade nicht erreichbar. Weiter unten findest du viele Beispiele.', true); })
      .then(function () { knopf.disabled = false; if (nochmal) nochmal.disabled = false; var s = box.querySelector('.fzt-gen__schreiben'); if (s) s.hidden = true; });
  }

  // Anonyme Zählung für die Funnel-Übersicht im ERP (keine Cookies, keine IDs).
  function zaehlen(art) {
    try { if (navigator.sendBeacon) navigator.sendBeacon(ENDPUNKT + '/klick', art); } catch (e) {}
  }
  var aufgeklapptGezaehlt = false;
  box.addEventListener('toggle', function () {
    if (box.open && !aufgeklapptGezaehlt) { aufgeklapptGezaehlt = true; zaehlen('aufgeklappt'); }
  });
  var cta = box.querySelector('.fzt-gen__cta a');
  if (cta) cta.addEventListener('click', function () { zaehlen('taufkerze'); });

  // Ankunft von der Bestellseite oder aus der Freigabe-Mail (?von=status /
  // ?von=freigabemail, 09.10.2026): einmal zählen und den Generator gleich
  // aufgeklappt zeigen — der Link verspricht „Fürbitten erstellen".
  try {
    var von = new URLSearchParams(location.search).get('von');
    if (von === 'status' || von === 'freigabemail') {
      zaehlen(von);
      aufgeklapptGezaehlt = true;
      box.open = true;
      setTimeout(function () { box.scrollIntoView({ block: 'start' }); }, 50);
    }
  } catch (e) {}

  // Fürbitten-Funnel (Christian 09.10.2026): PDF per E-Mail, Newsletter freiwillig.
  var mailKnopf = box.querySelector('[data-fzt-mail]');
  var mailStatus = box.querySelector('.fzt-gen__mailstatus');
  function mailMeldung(text, fehler) {
    mailStatus.textContent = text || '';
    mailStatus.className = 'fzt-gen__mailstatus' + (fehler ? ' fzt-gen__mailstatus--fehler' : '');
  }
  if (mailKnopf) mailKnopf.addEventListener('click', function () {
    if (!letzte || !letzte.beleg) { mailMeldung('Bitte erstelle zuerst eure Fürbitten.', true); return; }
    var adresse = (box.querySelector('input[name="mail"]').value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(adresse)) { mailMeldung('Bitte gib eine gültige E-Mail-Adresse ein.', true); return; }
    var nl = box.querySelector('input[name="newsletter"]').checked;
    var nameJetzt = (form.elements.kindname.value || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    mailKnopf.disabled = true;
    mailMeldung('Einen Moment – dein PDF wird erstellt und verschickt …');
    fetch(ENDPUNKT + '/mail', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mail: adresse, name: nameJetzt, fuerbitten: letzte.fuerbitten,
        antwortruf: letzte.antwortruf, beleg: letzte.beleg, newsletter: nl,
        website: form.elements.website ? form.elements.website.value : '' }) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (d) {
        if (d && d.ok) {
          mailMeldung(nl ? 'Verschickt! Bitte bestätige noch den Link in der Mail – dann kommt dein 5-%-Gutschein.'
                         : 'Verschickt! Schau gleich in dein Postfach.');
        } else {
          mailMeldung((d && d.fehler) || 'Die Mail konnte gerade nicht verschickt werden. Bitte versuch es später noch einmal.', true);
        }
      })
      .catch(function () { mailMeldung('Die Mail konnte gerade nicht verschickt werden. Bitte versuch es später noch einmal.', true); })
      .then(function () { mailKnopf.disabled = false; });
  });

  form.addEventListener('submit', function (e) { e.preventDefault(); anfragen(); });
  if (nochmal) nochmal.addEventListener('click', anfragen);
  form.elements.kindname.addEventListener('input', zeigen);
  if (kopieren) kopieren.addEventListener('click', function () {
    if (!letzte) return;
    zaehlen('kopieren');
    var text = alsText();
    var fertig = function () { kopieren.textContent = 'Kopiert ✓'; setTimeout(function () { kopieren.textContent = 'Alle kopieren'; }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(fertig, function () {}); }
    else { var t = document.createElement('textarea'); t.value = text; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); fertig(); } catch (e) {} document.body.removeChild(t); }
  });
})();
